import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../baseDialog/BaseDialog";

const UnsavedChangesDialog = props => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    size={props.size || "md"}
    title={props.t("UnsavedChangesDialog.Title")}
    body={props.t("UnsavedChangesDialog.Text")}
    leftButtonVariant="black"
    rightButtonVariant="green"
    rightButtonCallback={props.onSubmit}
    dialogApiError={props.dialogApiError}
    rightButtonText={props.t("UnsavedChangesDialog.ConfirmButton")}
    leftButtonText={props.t("DialogCancel")}
    leftButtonCallback={props.onHide}
  />
);


export default withTranslation()(UnsavedChangesDialog);
